import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgClock = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10 2C12.1217 2 14.1566 2.84285 15.6569 4.34315C17.1571 5.84344 18 7.87827 18 10C18 12.1217 17.1571 14.1566 15.6569 15.6569C14.1566 17.1571 12.1217 18 10 18C7.87827 18 5.84344 17.1571 4.34315 15.6569C2.84285 14.1566 2 12.1217 2 10C2 7.87827 2.84285 5.84344 4.34315 4.34315C5.84344 2.84285 7.87827 2 10 2ZM9.25 5.75V10C9.25 10.4156 9.58437 10.75 10 10.75H13.25C13.6656 10.75 14 10.4156 14 10C14 9.58437 13.6656 9.25 13.25 9.25H10.75V5.75C10.75 5.33437 10.4156 5 10 5C9.58437 5 9.25 5.33437 9.25 5.75Z",
		fill: "#0D2976"
	})
});
export default SvgClock;
